import React, { useEffect, useRef, useState } from "react";
import { Project } from "./types";

export interface InlineCreateProps {
  projects: Project[];
  defaultProjectKey: string;
  onSubmit: (summary: string, projectKey: string) => void;
  onCancel: () => void;
}

const InlineCreate: React.FC<InlineCreateProps> = ({ projects, defaultProjectKey, onSubmit, onCancel }) => {
  const [value, setValue] = useState<string>("");
  const [projectKey, setProjectKey] = useState<string>(defaultProjectKey);
  const textareaRef: React.RefObject<HTMLTextAreaElement> = useRef<HTMLTextAreaElement>(null);
  const showProjectPicker: boolean = projects.length > 1;

  useEffect(() => {
    textareaRef.current?.focus();
  }, []);

  const commit = (): void => {
    const trimmed: string = value.trim();
    if (trimmed) {
      onSubmit(trimmed, projectKey);
      setValue("");
    } else {
      onCancel();
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>): void => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      commit();
    } else if (event.key === "Escape") {
      event.preventDefault();
      onCancel();
    }
  };

  return (
    <div className="kuika-board__inline-create" data-testid="board-inline-create">
      <textarea
        ref={textareaRef}
        data-testid="board-inline-create-input"
        value={value}
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => setValue(event.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={() => {
          if (!value.trim()) onCancel();
        }}
        placeholder="What needs to be done?"
        rows={2}
      />
      <div className="kuika-board__inline-create-hint">
        {showProjectPicker && (
          <select
            className="kuika-board__inline-create-project"
            value={projectKey}
            onChange={(event: React.ChangeEvent<HTMLSelectElement>) => setProjectKey(event.target.value)}
            onMouseDown={(event: React.MouseEvent) => event.stopPropagation()}
          >
            {projects.map((project: Project) => (
              <option key={project.key} value={project.key}>
                {project.key} · {project.name}
              </option>
            ))}
          </select>
        )}
        <span>
          <span className="kuika-board__inline-create-kbd">↵</span> save
        </span>
        <span>
          <span className="kuika-board__inline-create-kbd">esc</span> cancel
        </span>
      </div>
    </div>
  );
};

export default InlineCreate;
